export function captureFrame(videoElement) {
  if (!videoElement) return;

  const canvas = document.createElement("canvas");
  canvas.width = videoElement.videoWidth;
  canvas.height = videoElement.videoHeight;

  if (canvas.width === 0 || canvas.height === 0) {
    console.warn("비디오가 아직 로드되지 않음");
    return;
  }

  const ctx = canvas.getContext("2d");
  ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

  const dataUrl = canvas.toDataURL("image/png");

  return dataUrl;
}
